module.exports = {
  "country": "TR",
  "artist": "Hadise",
  "song": "Düm Tek Tek",
  "year": "2009",
  "place": "4",
  "spotify": "1l9jCFXKfkw33BwkGytqkO"
};